// Overcoming Challenge Template
export const overcomingChallengeTemplate = {
  id: 'overcomingChallenge',
  title: 'Overcoming Challenge',
  description: 'Ideal for demonstrating problem-solving, resilience, and personal strength when facing external obstacles',
  sections: [
    {
      id: 'crisis_moment',
      label: 'The Crisis Moment',
      type: 'opening',
      prompt: 'Set the scene. What specific moment made you realize this wasn\'t a problem you could solve the usual way?',
      coachVoice: "I want to feel the weight of this moment. What did you see, hear, or realize that changed everything?",
      sample: "My phone buzzed at 2 AM with a text from my mom: 'Dad's in the hospital. Heart attack. Need you to handle your sister's school stuff tomorrow.' I stared at the message, knowing my AP exam was in 6 hours and my sister's IEP meeting was at 10 AM.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'what_made_different',
      label: 'What Made This Different',
      type: 'stakes',
      prompt: 'Why couldn\'t you handle this challenge the way you\'d handled problems before?',
      coachVoice: "Don't say 'it was stressful.' Every challenge is stressful. What made this one require a completely different version of you?",
      sample: "Usually I could compartmentalize - school problems stayed at school, family issues stayed at home. But this crisis demanded I become the family coordinator while maintaining my academic performance, two roles that seemed to require completely different versions of myself.",
      minWords: 80,
      unlockWords: 40
    },
    {
      id: 'unique_approach',
      label: 'Your Unique Solution',
      type: 'approach',
      prompt: 'Show me your unique approach. What systems, strategies, or thinking patterns did you develop?',
      coachVoice: "This is where I learn how YOUR brain works under pressure. What did you create that others wouldn't have?",
      sample: "I developed what I called 'dual-track thinking' - I'd set 15-minute timers and alternate between family coordination calls and chemistry review, treating each switch like a mental gear change. I even created a shared calendar system so my mom could track my availability between study sessions.",
      minWords: 100,
      unlockWords: 50
    },
    {
      id: 'lasting_impact',
      label: 'The Lasting Impact',
      type: 'growth',
      prompt: 'How did this experience change how you approach challenges? Give me a specific example of this change in action.',
      coachVoice: "I need proof this wasn't just a one-time thing. How does this new approach show up in your life now?",
      sample: "When my friend Sarah's parents divorced junior year and her grades tanked, I found myself automatically suggesting she break down her problems into manageable chunks with timers. I realized I'd become someone who sees crisis management as a learnable skill, not an innate talent.",
      minWords: 80
    }
  ]
};